export const appConfig = {
  name: import.meta.env.VITE_APP_NAME || "4 Apex V2",
  supportEmail: import.meta.env.VITE_SUPPORT_EMAIL || "suporte@4apex.chat",
  trialDays: Number(import.meta.env.VITE_TRIAL_DAYS || 7),
  monthlyPriceCents: Number(import.meta.env.VITE_MONTHLY_PRICE_CENTS || 9900),
  billingEnabled: import.meta.env.VITE_BILLING_ENABLED === "true",
  // Demo is convenient during local development, but a deployed build must
  // fail closed when Supabase is missing instead of exposing fake access.
  allowDemo:
    import.meta.env.VITE_ALLOW_DEMO === "true" ||
    (import.meta.env.VITE_ALLOW_DEMO !== "false" && import.meta.env.DEV),
  widgetCdnUrl:
    import.meta.env.VITE_WIDGET_CDN_URL ||
    (typeof window === "undefined"
      ? "/widget/4apex-widget.iife.js"
      : new URL("/widget/4apex-widget.iife.js", window.location.origin).href),
};

export const formatMoney = (cents: number) =>
  new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
    maximumFractionDigits: 0,
  }).format(cents / 100);
